import {Component, Inject, OnInit} from '@angular/core';
import {ListView} from "@domain/common/list-view";
import {Role} from "@domain/workflow/role";
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';
import {TranslateService} from '@ngx-translate/core';
import {Page} from "@domain/common/http/list-result";
import {RelanceDetail} from "@domain/relance/relance-detail";
import {RoleRelanceListItemComponent} from "./role-list-item/role-relance-list-item.component";

/**
 * Popin de sélection des rôles pour une relance
 */
@Component({
    host: {'data-test-id': 'select-relance-roles-popin'},
    templateUrl: './select-relance-roles-popin.component.html'
})
export class SelectRelanceRolesPopinComponent implements OnInit {
    //Liste des rôles
    listeRoles: ListView<Role, RoleRelanceListItemComponent>;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { relance: RelanceDetail, listeRoles: Role[] },
        private translateService: TranslateService
    ) {
    }

    ngOnInit(): void {
        //Initialisation de la liste
        this.listeRoles = new ListView<Role, RoleRelanceListItemComponent>({
            title: this.translateService.instant('admin.bibliotheque.notifications.relances.selectRolesPopin.listTitle'),
            component: RoleRelanceListItemComponent,
            isFrontendList: true,
            data: {
                listeResultats: this.data.listeRoles,
                numPage: 0,
                nbPagesTotal: 1,
                nbObjetsTotal: this.data.listeRoles.length,
                nbObjetsParPage: this.data.listeRoles.length,
                nbObjetsDansPage: this.data.listeRoles.length
            } as Page<Role>,
            extraOptions: {
                relance: this.data.relance
            },
            listeActions: [{
                icon: 'done_all',
                onPress: () => this.listeRoles.selectAll(true),
                tooltip: this.translateService.instant('global.actions.toutSelectionner'),
                isVisible: () => !this.listeRoles?.data.listeResultats.every(r => r.isSelected)
            }, {
                icon: 'remove_done',
                onPress: () => this.listeRoles.selectAll(false),
                tooltip: this.translateService.instant('global.actions.toutDeselectionner'),
                isVisible: () => this.listeRoles?.data.listeResultats.every(r => r.isSelected)
            }]
        });
    }
}
